import React from 'react';
import PropTypes from 'prop-types';
import { Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'tabler-icons-react';
import ResponsiveWebstoreModal from './ResponsiveWebstoreModal';
import AppStack from '../../common/AppStack';
import ProductCareInstructions from './ProductCareInstructions';
import { PRODUCT_CATEGORY_TYPE_ENUM } from '../../../config/productCategories';
import AppFlexbox from '../../common/AppFlexbox';

const ProductCareInstructionsModal = ({
  ecomStoreCartProducts,
  mediaQueries,
  editModeEnabled,
  baseStoreUrl,
  onNavigate,
  isOpen,
  onClose
}) => (
  <ResponsiveWebstoreModal
    alignModal="center"
    editModeEnabled={editModeEnabled}
    isOpen={isOpen}
    mediaQueries={mediaQueries}
    onClose={onClose}
    radius={0}
    size={600}
    title="Product care Instructions"
    trapFocus={false}
    zIndex={201}
  >
    <AppStack style={{ gap: 25 }}>
      <ProductCareInstructions
        isSummaryView
        showApparel={ecomStoreCartProducts?.some(
          (e) =>
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct
              .fkEcomCategory === PRODUCT_CATEGORY_TYPE_ENUM.APPAREL &&
            !e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct.productType
              ?.toLowerCase()
              .includes('hat')
        )}
        showDrinkware={ecomStoreCartProducts?.some(
          (e) =>
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct
              .fkEcomCategory === PRODUCT_CATEGORY_TYPE_ENUM.DRINKWARE
        )}
        showHats={ecomStoreCartProducts?.some(
          (e) =>
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct
              .fkEcomCategory === PRODUCT_CATEGORY_TYPE_ENUM.APPAREL &&
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct.productType
              ?.toLowerCase()
              .includes('hat')
        )}
        showTotebags={ecomStoreCartProducts?.some(
          (e) =>
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct
              .fkEcomCategory === PRODUCT_CATEGORY_TYPE_ENUM.MISC &&
            e.ecomStoreProductVariant.ecomStoreProduct.ecomVendorProduct.productType
              ?.toLowerCase()
              .includes('bag')
        )}
      />

      <AppFlexbox
        style={{
          gap: 8,
          alignItems: 'center',
          marginTop: 5
        }}
      >
        <Anchor
          component={Link}
          onClick={onNavigate}
          style={{ fontSize: 14, color: 'dodgerblue' }}
          to={`${baseStoreUrl}/about/care-instructions`}
        >
          View Full Care Instructions Page
        </Anchor>
        <ArrowRight color="dodgerblue" size={16} />
      </AppFlexbox>
    </AppStack>
  </ResponsiveWebstoreModal>
);

ProductCareInstructionsModal.propTypes = {
  baseStoreUrl: PropTypes.string,
  ecomStoreCartProducts: PropTypes.array,
  editModeEnabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onClose: PropTypes.func,
  onNavigate: PropTypes.func
};

export default ProductCareInstructionsModal;
